import { Flex } from 'shared';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { CoachingSessionRecapMessageContent } from 'features/chat/config/types/Message';

import { CoachingSessionRecapContent } from './CoachingSessionRecap/Content';
import { CoachingSessionRecapHeader } from './CoachingSessionRecap/Header';
import { CoachingSessionViewRecap } from './CoachingSessionRecap/ViewRecap';

type ChatMessageCoachingSessionRecapProps =
  CoachingSessionRecapMessageContent & {
    isIncoming?: boolean;
  };

export const ChatMessageCoachingSessionRecap = ({
  coachingSessionId,
  subject,
  content,
  submittedAt,
  attachments,
  isIncoming,
}: ChatMessageCoachingSessionRecapProps) => (
  <Flex gap={2} flexDirection="column">
    <CoachingSessionRecapHeader
      subject={subject}
      submittedAt={submittedAt}
      color={isIncoming ? 'blackTotal' : 'whiteTotal'}
    />
    <CoachingSessionRecapContent
      content={content}
      color={isIncoming ? 'var(--black)' : 'var(--white)'}
    />
    <CoachingSessionViewRecap
      coachingSessionId={coachingSessionId}
      subject={subject}
      content={content}
      submittedAt={submittedAt}
      attachments={attachments}
      bg={isIncoming ? 'black' : 'rgba(255, 255, 255, 0.15)'}
    />
    <Spacer size="xsm zr" />
  </Flex>
);
